import { isEmpty } from '../Shared/scriptts/utilities';
import { Params } from '../Shared/scriptts/search-params';
import { params, aliasMapping } from './search-main';

export class URLCriteriaHelper {
    static ParseURL(existingParams: Params) {
        let myParams: Params = existingParams ? existingParams : new Params();
        let queryData = new URLSearchParams(window.location.search);
        let querySet = new Set(queryData.keys());
        for (const criteria of querySet) {
            if (criteria in aliasMapping) {
                const queryValues = queryData.getAll(criteria);
                if (myParams[aliasMapping[criteria].JOAQueryName] instanceof Array) {
                    myParams[aliasMapping[criteria].JOAQueryName] = queryValues;
                } else {
                    const firstValue = queryValues[0];
                    if (firstValue === "true") {
                        myParams[aliasMapping[criteria].JOAQueryName] = true;
                    } else if (firstValue === "false") {
                        myParams[aliasMapping[criteria].JOAQueryName] = false;
                    } else {
                        myParams[aliasMapping[criteria].JOAQueryName] = firstValue;
                    }
                }
            }
        }
        return myParams;
    }

    static reconstructUrl(replace: boolean = false) {
        let urlObject = {};
        let urlObjectString = `${window.location.href.split('?')[0]}?`;
        let paramString = '';

        for (const param in params) {
            const paramValue = params[param];
            if (!isEmpty(paramValue) && param in aliasMapping) {
                urlObject[aliasMapping[param].Abbreviation] = paramValue;
            }
        }
        for (const key in urlObject) {
            if (isEmpty(urlObject[key])) {
                delete urlObject[key];
            }
            else {
                paramString += Array.isArray(urlObject[key]) ? `&${key}=${urlObject[key].join(`&${key}=`)}` : `&${key}=${urlObject[key]}`;
            }
        }
        paramString = paramString.replace(/^&/, '');

        if (replace) {
            history.replaceState({}, document.title, encodeURI(urlObjectString + paramString));
        }
        else {
            history.pushState({}, document.title, encodeURI(urlObjectString + paramString));
        }
    }
}
